export enum ItemsTypes {
    Standard = 1,
    Serial,
    Batch,
    NonInventory,
    SerialwithQuantity
}

export enum RowValidation {
    Quantity = 1,
    IsItemExist = 2
}

export enum POValidation {
    Full = 1,
    PONumberOnly = 2,
    NotValidated = 3
}

export enum EntityStatus {
    Active = 1,
    Suspended,
    Deleted
}

export enum Pages {
    ReturnRransactions = 226,
    Sysreceives = 310,
    PurchaseOrders = 187
}